export const LANGUAGE_SELECTOR_START = "LANGUAGE_SELECTOR_START";
export const LANGUAGE_SELECTOR_FAIL = "LANGUAGE_SELECTOR_FAIL";
export const LANGUAGE_SELECTOR_CURRENT_LANGUAGE = "LANGUAGE_SELECTOR_CURRENT_LANGUAGE";
export const LANGUAGE_SELECTOR_CURRENT_LANGUAGE_SUCCESS = "LANGUAGE_SELECTOR_CURRENT_LANGUAGE_SUCCESS";
